import { render, staticRenderFns } from "./MunicipalityBotClients.vue?vue&type=template&id=54b8a35c&"
import script from "./MunicipalityBotClients.vue?vue&type=script&lang=js&"
export * from "./MunicipalityBotClients.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityBotClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports